export default __webpack_public_path__ + "static/media/AppStore.57c07125.png";